import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appNoSpaces]',
  standalone: true
})
export class NoSpacesDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    const newValue = value.replace(/\s/g, '');
    
    if (value !== newValue) {
      input.value = newValue;
      // Trigger input event to update the form control value
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData('text') || '';
    const cleanedText = pastedText.replace(/\s/g, '');
    
    const input = this.el.nativeElement as HTMLInputElement;
    const start = input.selectionStart || 0;
    const end = input.selectionEnd || 0;
    const currentValue = input.value;
    
    input.value = currentValue.substring(0, start) + cleanedText + currentValue.substring(end);
    input.setSelectionRange(start + cleanedText.length, start + cleanedText.length);
    
    // Trigger input event to update the form control value
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }
}

